import { useState } from "react";

const SUIT_LABELS = { vocals: "VOX", drums: "DRM", bass: "BASS", synths: "SYN", mix_bus: "MIX" };

const TYPE_HUES = { reverb: 190, delay: 160, compressor: 25, eq: 265, synthesizer: 320, distortion: 0, modulation: 210, mastering: 45, drums: 15, instrument: 140, sampler: 290, effect: 230, utility: 230 };

const ArtTile = ({ plugin }) => {
  const hue = TYPE_HUES[plugin.type] ?? 230;
  return (
    <div
      className="flex h-full w-full flex-col items-center justify-center gap-1"
      style={{ background: `linear-gradient(135deg, hsl(${hue},60%,10%), hsl(${hue},70%,18%))` }}
    >
      <span className="font-heading text-3xl font-black" style={{ color: `hsl(${hue},80%,65%)` }}>
        {(plugin.name || "?").charAt(0).toUpperCase()}
      </span>
      <span className="font-mono text-[9px] uppercase tracking-[0.3em]" style={{ color: `hsl(${hue},40%,55%)` }}>
        {plugin.brand?.slice(0, 18)}
      </span>
    </div>
  );
};

export const SuitabilityMeters = ({ suitability, size = "sm" }) => {
  const entries = Object.entries(SUIT_LABELS).filter(([k]) => suitability?.[k] != null);
  if (!entries.length) return null;
  return (
    <div className={`grid grid-cols-5 ${size === "sm" ? "gap-2" : "gap-4"}`}>
      {entries.map(([key, label]) => (
        <div key={key}>
          <div className="font-mono text-[9px] tracking-widest text-white/40">{label}</div>
          <div className="mt-1 h-1 overflow-hidden rounded-full bg-white/10">
            <div
              className={`suit-bar h-full rounded-full ${suitability[key] >= 7 ? "bg-cyan-400" : "bg-white/30"}`}
              style={{ width: `${(suitability[key] / 10) * 100}%` }}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export const PriceTag = ({ price, currency }) => {
  if (price == null) return <span className="font-mono text-xs text-white/40">See price</span>;
  if (price === 0) return <span className="font-mono text-xs font-semibold text-emerald-400">FREE</span>;
  const sym = currency === "GBP" ? "£" : currency === "EUR" ? "€" : "$";
  return <span className="font-mono text-xs font-semibold text-white/80">{sym}{price}</span>;
};

export const PluginCard = ({ plugin, index, onOpen }) => {
  const [imgFailed, setImgFailed] = useState(false);
  return (
    <button
      data-testid={`plugin-card-${index}`}
      onClick={onOpen}
      className="plugin-card anim-fade-up flex flex-col overflow-hidden rounded-md border border-white/10 bg-[#141417] text-left"
      style={{ animationDelay: `${index * 0.06}s` }}
    >
      <div className="relative h-36 w-full overflow-hidden bg-[#0d0d10]">
        {plugin.image && !imgFailed ? (
          <img src={plugin.image} alt={plugin.name} loading="lazy" onError={() => setImgFailed(true)} className="h-full w-full object-cover" />
        ) : (
          <ArtTile plugin={plugin} />
        )}
        <div className="absolute left-2.5 top-2.5 rounded bg-black/70 px-2 py-0.5 font-mono text-[10px] uppercase tracking-widest text-cyan-300 backdrop-blur-sm">
          {plugin.type}
        </div>
      </div>
      <div className="flex flex-1 flex-col gap-2.5 p-4">
        <div className="flex items-start justify-between gap-2">
          <div>
            <div className="font-heading text-[15px] font-bold leading-tight text-white">{plugin.name}</div>
            <div className="mt-0.5 text-xs text-white/45">{plugin.brand}</div>
          </div>
          <PriceTag price={plugin.price} currency={plugin.currency} />
        </div>
        {plugin.reason && (
          <p className="font-mono text-[11px] leading-relaxed text-cyan-300/85">{plugin.reason}</p>
        )}
        <div className="mt-auto pt-1">
          <SuitabilityMeters suitability={plugin.suitability} />
        </div>
      </div>
    </button>
  );
};
